<template>
  <div class="page-home">
    <div class="banner">
      <div class="content">
        <a class="title" href="#/flight-review/map">
          Newly released! Book your Flight Review now and get one year of RPAS
          Wilco PRO subscription for free!
        </a>
        <div class="sub-title">
          {{ $t("Looking to acquire a high-quality drone at a great price?") }}
          <a
            class="contect-btn"
            target="_blank"
            href="mailto:sales@aimrobotics.io"
          >
            Contact us now!
          </a>
        </div>
        <img
          class="scroll-down-mouse"
          src="/img/scroll-down-mouse.gif"
          alt=""
        />
      </div>
    </div>
    <div
      id="Home"
      style="backgroundImage: url(./img/background2x2.png); background-size: cover; min-height: 100vh"
    >
      <div v-if="mobilescreen" class="md-layout">
        <div
          class="md-layout-item md-size-100 md-small-size-100"
          style="height: 100px"
        >
          <br />
          <br />
        </div>
        <div class="md-layout-item md-size-40 md-small-size-100">
          <p>
            <font
              style="color: #2685BC; font-family: monospace; font-size: 36px; font-weight: 600;"
              >Drone Safety
            </font>
            <font style="color: #225990; font-size: 20px; font-weight: 500;">
              MADE EASY</font
            >
          </p>
          <br />
          <br />
        </div>
        <div
          class="md-layout-item md-align-center md-size-15 md-small-size-100"
        >
          <img style="min-width: 90%" src="/img/survey_sam.gif" />
        </div>
        <div class="md-layout-item md-size-40 md-small-size-100">
          <br />
          <md-button class="md-raised " @click="signup">
            <font style="font-size: 24px; color: white;">SIGN UP TODAY</font>
          </md-button>
          <br />
          <br />
          <p
            style="font-family: -webkit-pictograph; color: white; font-size: 20px;"
          >
            RPAS WILCO creates your site survey in less than a minute. In fact,
            when it comes to drone safety, we have you covered: flight planning,
            checklists, device maintenance, and more. Take control of your
            operations and fly safe with RPAS WILCO.
          </p>
          <br />
          <br />
          <md-button class="md-raised" @click="learnmore">
            <font style="font-size: 14px; color: white;">LEARN MORE</font>
          </md-button>
          &nbsp;&nbsp;&nbsp;
          <md-button
            style="outline: auto;"
            class="md-simple "
            @click="contactus"
          >
            <font style="font-size: 14px; color: white;">CONTACT US</font>
          </md-button>
          <br />
        </div>
        <div class="md-layout-item md-size-30 md-small-size-100">
          <br />
        </div>
        <div class="md-layout-item md-size-100 md-small-100"></div>
        <div class="md-layout-item md-size-30 md-small-size-100">
          <br />
          <br />
        </div>
      </div>

      <div v-else class="md-layout">
        <div
          class="md-layout-item md-size-100 md-small-size-100"
          style="height: 100px"
        >
          <br />
          <br />
        </div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <br />
          <br />
        </div>
        <div class="md-layout-item md-size-40 md-small-hide">
          <br />
          <p>
            <font
              style="color: #80EAFE; font-family: monospace; font-size: 36px; font-weight: 600;"
              >{{ $t("Drone Safety") }}
            </font>
            <font style="color: white; font-size: 20px; font-weight: 500;">
              {{ $t("MADE EASY") }}</font
            >
          </p>
        </div>
        <div
          class="md-layout-item md-align-center md-size-15 md-small-size-100"
        >
          <img src="/img/phone_sam_1.png" />
        </div>
        <div class="md-layout-item md-size-15 md-small-hide">
          <img style="width: 100%" src="/img/phone_sam_2.png" />
        </div>
        <div class="md-layout-item md-size-15 md-small-hide">
          <img style="width: 100%" src="/img/phone_sam_3.png" />
        </div>
        <div class="md-layout-item md-size-15 md-small-size-100"></div>
        <div class="md-layout-item md-size-40 md-small-hide">
          <img src="/img/rpaswilcomain.png" style="width: 60%" />
          <br />
          <br />
          <br />
          <md-button
            style="outline: auto;"
            class="md-simple md-round"
            @click="signup"
          >
            <font style="font-size: 38px; color: rgb(128, 234, 254);">{{
              $t("SIGN UP TODAY")
            }}</font>
          </md-button>
          <br />
          <br />
          <p style="color: white; font-size: 22px;">
            {{
              $t(
                "RPAS WILCO creates your site survey in less than a minute. In fact, when it comes to drone safety, we have you covered: flight planning, checklists, device maintenance, and more. Take control of your operations and fly safe with RPAS WILCO."
              )
            }}
          </p>
          <br />
          <br />&nbsp;
          <md-button class="md-raised " @click="learnmore">
            <font style="font-size: 18px; color: white;">{{
              $t("LEARN MORE")
            }}</font>
          </md-button>
          &nbsp;&nbsp;&nbsp;
          <md-button
            style="outline: auto;"
            class="md-simple "
            @click="contactus"
          >
            <font style="font-size: 18px; color: white;">{{
              $t("CONTACT US")
            }}</font>
          </md-button>
        </div>

        <div class="md-layout-item md-size-20 md-small-size-100">
          <br />
          <br />
          <br />
        </div>
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-100 md-small-100"></div>
        <div class="md-layout-item md-size-30 md-small-size-100">
          <br />
          <br />
        </div>
      </div>

      <modal v-if="showSignup">
        <template slot="header">
          <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="closeSignup"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <register></register>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
import { EventBus } from "@/helpers";
import Register from "@/pages/Landing/Register.vue";
import swal from "sweetalert2";

export default {
  name: "home",
  data() {
    return {
      showSignup: false,
      mobilescreen: false
    };
  },
  components: {
    Modal,
    Register
  },
  mounted() {
    this.onResponsiveInverted();
    EventBus.$on("signedup", () => {
      this.showSignup = false;
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t(
          "You successfully signed up. Please check your email to activate your account!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    signup() {
      this.$router.push("/signup");
    },
    closeSignup() {
      this.showSignup = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 800) {
        this.mobilescreen = true;
      } else {
        this.mobilescreen = false;
      }
    },
    contactus() {
      this.$router.push("/ContactUs");
    },
    learnmore() {
      this.$router.push("/Product");
    }
  },
  beforeDestroy() {
    window.addEventListener("resize", this.onResponsiveInverted);
    EventBus.$off("signedup");
  }
};
</script>

<style lang="css">
.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  overflow-y: auto;
}

.page-home {
  .banner {
    width: 100%;
    height: 100vh;
    background: url(/img/home-banner.jpg) no-repeat center center fixed;
    background-size: cover;
    position: relative;
    .content {
      position: absolute;
      width: 100%;
      height: 40vh;
      bottom: 0;
      text-align: center;
      left: 0;
      right: 0;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.1),
        rgba(0, 0, 0, 0.6)
      );
      .title {
        display: inline-block;
        color: #fff;
        font-size: 36px;
        width: 60%;
        margin: 40px auto 20px auto;
        line-height: 36px;
        &:hover {
          color: #fff !important;
          text-decoration: underline !important;
        }
      }
      .sub-title {
        color: #fff;
        font-size: 15px;
      }
    }
    .scroll-down-mouse {
      width: 80px;
      margin-top: 20px;
    }
  }
  @media all and (max-width: 768px) {
    .banner {
      .content {
        margin-left: 0;
        top: 20vh;
        height: 80%;
        .title {
          width: 100%;
        }
      }
    }
  }
}
</style>
